import request from '@/utils/request'
import {isEmpty} from "@/utils/tool";

/**
 * 超期导出购买证
 */
export const exportGmzExcel = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/gmz/spcs/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 超期导出运输证
 */
export const exportYszExcel = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/ysz/spcs/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 许可证超期率统计
 */
export const exportXkzCqlExcel = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzcql/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 许可证不规范-购买证购销单位一致
 */
export const exportBgfGmzGxdwyz = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzbgfGmxsyz/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 许可证不规范-购买证的销售单位已入网但没有生产或经营业务类型
 */
export const exportBgfGmzXsdwNoYwlx = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzbgfGmzXsdwNoywlx/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 许可证不规范-购买/退货运输的运输证与购买证相关单位不对应
 */
export const exportBgfYszdwbdy = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzbgfYszdwbdy/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})
/**
 * 许可证不规范-运输证：多方运输不能形成一条链或一条链的首尾单位不对应
 */
export const exportBgfDfys = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzbgfDfys/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})
/**
 * 预警处置-处置超期率统计
 */
export const exportYjczCzjslTj = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/yjczCzjslTj/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})
/**
 * 预警处置-已预警3次及以上，未实地核查
 */
export const exportScyjAndNoSdhc = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/scyjAndNoSdhc/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})
/**
 * 许可证核查核销情况
 */
export const exportXkzHchxtj = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/sysgakh/xkzHchxtj/excelwriter${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})
